import { render, staticRenderFns } from "./AddQuotation.vue?vue&type=template&id=1164dcd6&"
import script from "./AddQuotation.vue?vue&type=script&lang=js&"
export * from "./AddQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1164dcd6')) {
      api.createRecord('1164dcd6', component.options)
    } else {
      api.reload('1164dcd6', component.options)
    }
    module.hot.accept("./AddQuotation.vue?vue&type=template&id=1164dcd6&", function () {
      api.rerender('1164dcd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/AddQuotation.vue"
export default component.exports